"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distriMasServiciosNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const extractProductInfoItem = (product) => {
    if (!product) {
        return null;
    }
    const res = {
        name: product.name,
        alias: product.alias,
    };
    const { fields } = product;
    if (fields) {
        res.labelCard = fields === null || fields === void 0 ? void 0 : fields.labelCard;
        res.imageCard = { imgSrc: fields === null || fields === void 0 ? void 0 : fields.imgSrc, imgSrcWebp: fields === null || fields === void 0 ? void 0 : fields.imgSrcWebp, alt: fields === null || fields === void 0 ? void 0 : fields.altSEO, title: fields === null || fields === void 0 ? void 0 : fields.titleSEO };
        res.description = fields === null || fields === void 0 ? void 0 : fields.description;
        res.nombreComercial = fields === null || fields === void 0 ? void 0 : fields.title;
        res.crossedPrice = fields === null || fields === void 0 ? void 0 : fields.crossedPrice;
        res.postPrice = fields === null || fields === void 0 ? void 0 : fields.postPrice;
        res.prePrice = fields === null || fields === void 0 ? void 0 : fields.prePrice;
        res.price = fields === null || fields === void 0 ? void 0 : fields.price;
        res.promoLabel = fields === null || fields === void 0 ? void 0 : fields.promoLabel;
        res.promoLabelTheme = fields === null || fields === void 0 ? void 0 : fields.promoLabelTheme;
        res.unityCrossedPrice = fields === null || fields === void 0 ? void 0 : fields.unityCrossedPrice;
        res.unityPrice = fields === null || fields === void 0 ? void 0 : fields.unityPrice;
        res.link = fields === null || fields === void 0 ? void 0 : fields.link;
        res.btn = fields === null || fields === void 0 ? void 0 : fields.btn;
        res.targetUrl = fields === null || fields === void 0 ? void 0 : fields.target;
    }
    return res;
};
const extractProductInfo = (product) => {
    if (Array.isArray(product)) {
        return product.map((productItem) => extractProductInfoItem(productItem));
    }
    else {
        return extractProductInfoItem(product);
    }
};
const normalizeOrionStructureItem = (product) => {
    var _a, _b;
    let res = null;
    if (product) {
        res = {};
        const imageCard = product === null || product === void 0 ? void 0 : product.imageCard;
        const textRecommended = product === null || product === void 0 ? void 0 : product.labelCard;
        const nombreComercial = product === null || product === void 0 ? void 0 : product.nombreComercial;
        const description = product === null || product === void 0 ? void 0 : product.description;
        const promoLabel = product === null || product === void 0 ? void 0 : product.promoLabel;
        const promoLabelTheme = product === null || product === void 0 ? void 0 : product.promoLabelTheme;
        const prePrice = product === null || product === void 0 ? void 0 : product.prePrice;
        const postPrice = product === null || product === void 0 ? void 0 : product.postPrice;
        const targetUrl = product.targetUrl;
        let textPrice = "";
        const crossedPrice = product === null || product === void 0 ? void 0 : product.crossedPrice;
        const button = Object.assign({}, (_a = product === null || product === void 0 ? void 0 : product.btn) === null || _a === void 0 ? void 0 : _a.fields);
        const buttonLink = Object.assign({}, (_b = product === null || product === void 0 ? void 0 : product.link) === null || _b === void 0 ? void 0 : _b.fields);
        if (!!button) {
            // eliminar cuando se cambié el dato en la contri
            button.type = "primary";
            button.height = "small";
            button.width = "default";
        }
        if (!!buttonLink) {
            // eliminar cuando se cambié el dato en la contri
            buttonLink.height = "small";
            buttonLink.width = "default";
        }
        if (imageCard && imageCard.imgSrc && imageCard.imgSrcWebp) {
            res["Image-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Image-1"]), { src: "https://prod.cms.col.movistar.es" + imageCard.imgSrc, srcWebp: "https://prod.cms.col.movistar.es" + imageCard.imgSrcWebp, alt: imageCard.alt || nombreComercial, title: imageCard.title || nombreComercial, hash: global.hash || '' });
        }
        let currency = "";
        let quote = "";
        if (product === null || product === void 0 ? void 0 : product.unityPrice) {
            const currencySplit = product.unityPrice.split("/");
            currency = currencySplit[0];
            quote = currencySplit[1] || "";
        }
        let price1 = { currency };
        let price2 = { price: product === null || product === void 0 ? void 0 : product.price, currency, quote };
        if (product.alias) {
            res.alias = product.alias || "";
        }
        if (!!crossedPrice) {
            if ((product === null || product === void 0 ? void 0 : product.price) !== crossedPrice) {
                price1.price = crossedPrice;
                price2 = Object.assign(Object.assign({}, price2), { price: product.price, color: "red_dark" });
            }
        }
        else {
            if (!(product === null || product === void 0 ? void 0 : product.price)) {
                price2 = {
                    price: null,
                    currency: product === null || product === void 0 ? void 0 : product.unityPrice,
                    quote: "",
                };
            }
            if (!(product === null || product === void 0 ? void 0 : product.unityPrice)) {
                price2 = {
                    price: null,
                    currency: "",
                    quote: "",
                };
                textPrice = product === null || product === void 0 ? void 0 : product.price;
            }
        }
        if (!!nombreComercial) {
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: nombreComercial });
        }
        if (!!description) {
            res["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: description });
        }
        if (!!prePrice) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: prePrice });
        }
        if (!!postPrice) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: postPrice });
        }
        if (!!textRecommended) {
            res["Label-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-0"]), { text: textRecommended });
        }
        if (!!promoLabel) {
            res["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { label: promoLabel, theme: promoLabelTheme || mocks_json_1.default["Label-1"].theme });
        }
        if (price1 && price1.price) {
            res["Price-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-1"]), price1);
        }
        if (price2 && (price2.price || price2.currency)) {
            res["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-2"]), price2);
        }
        if (textPrice) {
            res["Price-Text"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-Text"]), { text: textPrice });
        }
        if (button && button.href) {
            let finalhref = button.href;
            if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
                finalhref =
                    button.href.trim().length > 0
                        ? button.href.indexOf("?") !== -1
                            ? `${button.href}&utm_source=novum`
                            : `${button.href}?utm_source=novum`
                        : "";
            }
            res["Button-1"] = Object.assign(Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), button), { href: finalhref });
        }
        else if (button && button.idModal || button.anchor) {
            res["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), button);
        }
        if (buttonLink && buttonLink.href) {
            res["Button-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-3"]), buttonLink);
            res["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-1"]), { href: buttonLink.href, title: nombreComercial || "" });
            if (!!targetUrl) {
                res["CustomLink-1"].target = targetUrl;
                res["Button-3"].target = targetUrl;
            }
        }
        // if (offerInfo.titleLegal && offerInfo.legal) {
        //     res["Legal-1"] = {
        //         "Text-1": { ...mock["Legal-1"]["Text-1"], text: offerInfo.titleLegal },
        //         "Text-2": { ...mock["Legal-1"]["Text-2"], text: offerInfo.legal },
        //     };
        // }
    }
    return res;
};
const normalizeOrionStructure = (products, topTitle, subTitle, topBackgroundColor) => {
    if (Array.isArray(products)) {
        let productsObj = {};
        productsObj["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-0"]), { text: topTitle || "", color: topBackgroundColor || "" });
        productsObj["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-01"]), { text: subTitle || "" });
        products.forEach((product, i) => (productsObj[`Product-${i + 1}`] = normalizeOrionStructureItem(product)));
        return productsObj;
    }
    else {
        return {
            "Product-1": normalizeOrionStructureItem(products, topTitle, topBackgroundColor),
            "Text-1": Object.assign(Object.assign({}, mocks_json_1.default["Text-0"]), { text: topTitle, color: topBackgroundColor }),
        };
    }
};
/**
 * normalizador del modulo MODULO_BUYBOX
 * @param {object} fields
 * @returns
 */
const distriMasServiciosNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    try {
        let res = {};
        if (Array.isArray(data)) {
            data.forEach((element, i) => {
                var _a, _b, _c, _d, _e;
                const topTitle = (_a = element === null || element === void 0 ? void 0 : element.fields) === null || _a === void 0 ? void 0 : _a.title;
                const subTitle = ((_b = element === null || element === void 0 ? void 0 : element.fields) === null || _b === void 0 ? void 0 : _b.subTitle) ? (_c = element === null || element === void 0 ? void 0 : element.fields) === null || _c === void 0 ? void 0 : _c.subTitle : "";
                const topBackgroundColor = (_d = element === null || element === void 0 ? void 0 : element.fields) === null || _d === void 0 ? void 0 : _d.backgroundColor;
                const products = extractProductInfo((_e = element === null || element === void 0 ? void 0 : element.fields) === null || _e === void 0 ? void 0 : _e.cards);
                res[`List-${i}`] = normalizeOrionStructure(products, topTitle, subTitle, topBackgroundColor);
                res["Name"] = "MORE_SERVICES_BOX";
                return res;
            });
            return res;
        }
        else {
            if (Array.isArray((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.cards)) {
                const topTitle = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.title;
                const subTitle = ((_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.subTitle) ? (_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.subTitle : "";
                const topBackgroundColor = (_e = data === null || data === void 0 ? void 0 : data.fields) === null || _e === void 0 ? void 0 : _e.backgroundColor;
                const products = extractProductInfo((_f = data === null || data === void 0 ? void 0 : data.fields) === null || _f === void 0 ? void 0 : _f.cards);
                res[`List-0`] = normalizeOrionStructure(products, topTitle, subTitle, topBackgroundColor);
                res["Name"] = "DISTRI_SEGUROS_BOX";
                return res;
            }
            if (Array.isArray((_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.fields) === null || _g === void 0 ? void 0 : _g["MODULO_CARDS-DISTRI"]) === null || _h === void 0 ? void 0 : _h.fields) === null || _j === void 0 ? void 0 : _j.cards)) {
                const { title, cards } = (_l = (_k = data === null || data === void 0 ? void 0 : data.fields) === null || _k === void 0 ? void 0 : _k["MODULO_CARDS-DISTRI"]) === null || _l === void 0 ? void 0 : _l.fields;
                if (Array.isArray(cards)) {
                    const topTitle = title;
                    const subTitle = ((_m = data === null || data === void 0 ? void 0 : data.fields) === null || _m === void 0 ? void 0 : _m.subTitle) ? (_o = data === null || data === void 0 ? void 0 : data.fields) === null || _o === void 0 ? void 0 : _o.subTitle : "";
                    const topBackgroundColor = (_p = data === null || data === void 0 ? void 0 : data.fields) === null || _p === void 0 ? void 0 : _p.backgroundColor;
                    const products = extractProductInfo(cards);
                    res[`List-0`] = normalizeOrionStructure(products, topTitle, subTitle, topBackgroundColor);
                    res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { size: "title06", text: topTitle });
                    res["Name"] = "ZONAS_CONTRATO";
                    return res;
                }
            }
        }
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.distriMasServiciosNormalizer = distriMasServiciosNormalizer;
exports.default = exports.distriMasServiciosNormalizer;
//# sourceMappingURL=index.js.map